'use client';

// import { useLenis } from 'lenis/react';

// import useSnapStore, { SnapPoint } from '~/lib/store/snap';

// const isSnapPoint = (snapPoint?: SnapPoint): snapPoint is SnapPoint =>
//   snapPoint !== undefined;

const ScrollSnap = () => {
  // const snapPoints = useSnapStore((state) => state.snapPoints);

  // useLenis(
  //   (lenis) => {
  //     if (!lenis.isScrolling) {
  //       if (snapPoints) {
  //         const closestSnapPoint = snapPoints
  //           .map((snapPoint) => {
  //             if (snapPoint.ref && snapPoint.ref.current) {
  //               const { top, height } =
  //                 snapPoint.ref.current.getBoundingClientRect();

  //               return {
  //                 ...snapPoint,
  //                 distancePixels: top + height * snapPoint.position,
  //               } as SnapPoint;
  //             }
  //           })
  //           .filter(isSnapPoint)
  //           .reduce(
  //             (acc, snapPoint) => {
  //               if (
  //                 acc &&
  //                 acc.distancePixels !== undefined &&
  //                 snapPoint.distancePixels !== undefined &&
  //                 Math.abs(acc.distancePixels) <
  //                   Math.abs(snapPoint.distancePixels)
  //               ) {
  //                 return acc;
  //               }
  //               return snapPoint;
  //             },
  //             null as SnapPoint | null
  //           );

  //         if (
  //           closestSnapPoint &&
  //           closestSnapPoint.distancePixels !== undefined
  //         ) {
  //           const threshold =
  //             closestSnapPoint.distancePixels >= 0
  //               ? closestSnapPoint.thresholds[0]
  //               : closestSnapPoint.thresholds[1];

  //           const thresholdRawValue =
  //             typeof threshold === 'object' ? threshold.value : threshold;

  //           const thresholdUnit =
  //             typeof threshold === 'object' ? threshold.unit : 'px';

  //           const thresholdPixels =
  //             thresholdUnit === 'px'
  //               ? thresholdRawValue
  //               : window.innerHeight * thresholdRawValue;

  //           if (Math.abs(closestSnapPoint.distancePixels) <= thresholdPixels) {
  //             lenis.scrollTo(
  //               lenis.actualScroll + closestSnapPoint.distancePixels
  //             );
  //           }
  //         }
  //       }
  //     }
  //   },
  //   [snapPoints]
  // );

  return null;
};

export default ScrollSnap;
